import { eventChannel } from 'dva/saga';
import { socket } from '../utils/firebase';
import { generateId } from '../utils/generateId';
import errorHandler from '../utils/errorHandler';
import { createLog } from './firebase'
import AuthService from '../utils/AuthProvider'
import config from '@/../config';

const listApis = config.fireStoreListApis
/*
const listApis = {
  'productionLine':'https://g7qchqmu6eecddrljof7k7cp5q0shxxn.lambda-url.us-east-2.on.aws/',
  'plant':'https://o6grsi3b7axbhr5oejjo63gfm40uzzvn.lambda-url.us-east-2.on.aws/',
  'disconnectLog':'https://luf4tpmjdktzabpfcv3hrmrsru0yzlxb.lambda-url.us-east-2.on.aws/',
  'downtimeLog':'https://h63eqf4i25ud3dfjsyz5p7afhu0rtpvu.lambda-url.us-east-2.on.aws/',
  'dynamicAdjustments':'https://xzzgskiczp6i3yu7zigsxmdjz40dssyd.lambda-url.us-east-2.on.aws/',
  'headcount':'https://wtk4wtnm3vqosp4oeskrvbmdia0qubzm.lambda-url.us-east-2.on.aws/',
  'plannedDowntimes':'https://awnyzhl53yjwutzrg4fcbzzk2i0iwlsl.lambda-url.us-east-2.on.aws/',
  'productLog':'',
  'products':'https://ikbqecxjdmtj4uhsubxvkts3py0paeag.lambda-url.us-east-2.on.aws/',
  'roles':'https://ixeun6zsemhekk5xc5mgzg2piu0xmakr.lambda-url.us-east-2.on.aws/',
  'stats':'https://oocl2jy2sf2xulyvq75ccj5i3i0uvnke.lambda-url.us-east-2.on.aws/',
  'batches':'https://lbjfm4a7hwqdtss34cqhuaaeji0usocn.lambda-url.us-east-2.on.aws/',
  //'integrations':'',
  //'batchesForOperator':'',
  'mergeStatsList':'https://wh2qq42n766srymh42p4wsvony0besfc.lambda-url.us-east-2.on.aws/',
}*/
/*const apisList = {
  'disconnectLog':'https://luf4tpmjdktzabpfcv3hrmrsru0yzlxb.lambda-url.us-east-2.on.aws/',
  'downtimeLog':'https://h63eqf4i25ud3dfjsyz5p7afhu0rtpvu.lambda-url.us-east-2.on.aws/',
  'dynamicAdjustments':'https://xzzgskiczp6i3yu7zigsxmdjz40dssyd.lambda-url.us-east-2.on.aws/',
  'headcount':'https://wtk4wtnm3vqosp4oeskrvbmdia0qubzm.lambda-url.us-east-2.on.aws/',
  'plannedDowntimes':'https://awnyzhl53yjwutzrg4fcbzzk2i0iwlsl.lambda-url.us-east-2.on.aws/',
  'productLog':'',
  'products':'https://ikbqecxjdmtj4uhsubxvkts3py0paeag.lambda-url.us-east-2.on.aws/',
  'roles':'https://ixeun6zsemhekk5xc5mgzg2piu0xmakr.lambda-url.us-east-2.on.aws/',
  'stats':'https://oocl2jy2sf2xulyvq75ccj5i3i0uvnke.lambda-url.us-east-2.on.aws/',
  'batches':'https://lbjfm4a7hwqdtss34cqhuaaeji0usocn.lambda-url.us-east-2.on.aws/',
  'integrations':'',
  'batchesForOperator':'',
  'mergeStatsList':'https://wh2qq42n766srymh42p4wsvony0besfc.lambda-url.us-east-2.on.aws/',
  //
}*/
const createApis = config.fireStoreCreateApis;
const deleteApis = config.fireStoreDeleteApis;
const apis = config.fireStoreApis;
const getApis = config.fireStoreGetApis;
const updateApis = config.fireStoreUpdateApis
/*
const createApis = {
  'downtimeLog':'https://xhqeqit7v6qsseitxh56ryunwa0abnmo.lambda-url.us-east-2.on.aws/',
  'dynamicAdjustments':'https://bbhcqnn43e4jcyhcvln6lxqary0vbnqs.lambda-url.us-east-2.on.aws/',
  'headcount':'https://x4wm4rkpaq2y24huqzlj3ndbb40msgsi.lambda-url.us-east-2.on.aws/',
  'plannedDowntimes':'https://xsjfvuj6bs24lx2jx4i477lahu0xjunq.lambda-url.us-east-2.on.aws/',
  'plant':'https://vorve3tq5nizylllryb3ijroqm0tcgjt.lambda-url.us-east-2.on.aws/',
  'products':'https://kdc2cyp7tdg4m2cota2gdvrd4u0xdkdc.lambda-url.us-east-2.on.aws/',
  'productionLine':'https://wrkxu25eqqoihjphionfynnv4e0pihqm.lambda-url.us-east-2.on.aws/',
  'productLog':'https://ipqvllyf5anihgx3wmkrv4twge0gvkgj.lambda-url.us-east-2.on.aws/',
  'roles':'https://6i6cnpswjhu7pjrf3fxrvo6h3y0oklit.lambda-url.us-east-2.on.aws/',


}
const deleteApis = {
  'downtimelog':'https://hy7kgjxvaid7nmhhj2q4a7kl6q0trykc.lambda-url.us-east-2.on.aws/',
  'dynamicAdjustments':'https://3fy7zqveruuexb76id6a2f6zry0qmjni.lambda-url.us-east-2.on.aws/',
  'plannedDowntimes':'https://ay3kbp6y5ubooy222ehxzo4hsy0ntarp.lambda-url.us-east-2.on.aws/',
  'products':'https://gtagllrcmgl74fq67hplj7wuwm0jrvqh.lambda-url.us-east-2.on.aws/',
  'roles':'https://6t72qvvxeccfiblmqdugc6kjm40exlft.lambda-url.us-east-2.on.aws/',
  
}
const apis = {
  'bulkSyncMachines':'https://nwndjftkjn6cllq3isyc4l3geq0xfimz.lambda-url.us-east-2.on.aws/',
  'createMachine':'https://x7wnx42lxeu2ptxzllrocsdzwq0vvzzf.lambda-url.us-east-2.on.aws/',
  'productBatchQuery':'https://nydlkjttdysjokixgqh4lxl3ee0bnnej.lambda-url.us-east-2.on.aws/',
  'SyncShifts':'https://nt2p63r5rqihwkblljhdl3lufe0nuiih.lambda-url.us-east-2.on.aws/',
}
const getApis = {
  'roles':'https://ntk7woih5hxpeffphclchctlky0txxds.lambda-url.us-east-2.on.aws/',

}

const updateApis = {
  'headcount':'https://vchvwn2bd6cppfhxvvsms7a2nu0zuatt.lambda-url.us-east-2.on.aws/',
  'plannedDowntimes':'https://4uaqqyuqltuptwqbuzuuu2abhy0jiyfb.lambda-url.us-east-2.on.aws/',
  'plant':'https://wjbfrw3chhvyckoz2ptahvjl4q0mxjit.lambda-url.us-east-2.on.aws/',
  'products':'https://7awhlme3tbvv66kntroq2oppgy0elwlz.lambda-url.us-east-2.on.aws/',
  'productionLine':'https://lkkslmebd52cy7jixh3fgiqcr40psczb.lambda-url.us-east-2.on.aws/',
  'roles':'https://wb6nb7dggjmxslf3nfnnz2nely0dfvyp.lambda-url.us-east-2.on.aws/',
  'stats':'https://q4vw7d4ofx72frrktiq6h5bdzm0kyack.lambda-url.us-east-2.on.aws/'
}
*/
const moduleGenerateId = (module, params, data) => {
  return getModuleConfig(module, params).idGenerator(data);
};

const getModuleConfig = (module, params) => {
  let idGenerator = () => generateId(`${module.substr(0, 2)}`); // <== @todo: REPLACE THIS WITH UUID
  let db;
  switch (module) {
    case 'plant':
      idGenerator = ({ plantName }) => generateId('', { slug: plantName }); // should generate slug from data.name
      break;

    case 'productionLine':
      idGenerator = ({ lineName }) => generateId('', { slug: lineName }); // should generate slug from data.name
      break;

    case 'logs':
      idGenerator = ({ lineName, timestamp, userId }) => generateId('', { slug: lineName + userId + timestamp }); // should generate slug from data.name
      break;

    default:
      break;
  }

  return { db, idGenerator };
};

/**
 * Get list of documents
 */
export const list = async ({ module, params, orderBy, conditions, attributes, stream = true }) => {
  // if(module === 'stats') {
  //   console.log("module, params, orderBy, conditions, stream", module, params, orderBy, conditions, stream );
  //   return;
  // }
  // let ref = moduleGetDB(module, params);
  // where conditions [['key', '==', 'value'],...]
  // if (conditions) {
  //   conditions.map(condition => {
  //     if (condition.length < 3) {
  //       return console.error('Incorrect condition provided for firestore');
  //     }
  //     ref = ref.where(condition[0], condition[1], condition[2]);
  //   });
  // }

  params = params ? params : {}
  params.socketId = params.productionLineId ? `${params.productionLineId}-${module}` : module
  if (params.productionLineId) {
    conditions = conditions ? {
      ...conditions,
      lineId: params.productionLineId
    } :
      {
        lineId: params.productionLineId
      }
  }
  // conditions.machine = params && params.machine  ? params.machine : null
  if (params && conditions) {
    conditions.machine = params.machine ? params.machine : null
  }
  if (module == 'roles')
    params.socketId = `${conditions.plantId}-${module}`

  if (stream) {
    socket.emit('join', params.socketId);

    if (!window.rooms)
      window.rooms = [params.socketId]
    else if (!window.rooms.includes(params.socketId))
      window.rooms.push(params.socketId)
  }

  // order by
  // if (orderBy) ref = ref.orderBy(orderBy[0], orderBy[1]);
  return stream ? streamList({ params, module, socket, conditions, attributes }) : await queryList({ module, conditions, attributes });
};
/**
 * Get single document with provided id in params
 */
export const read = async ({ module, conditions, no404error = false, stream = true }) => {
  try {
    let token = await AuthService.getToken()
    let inputData = {conditions}
    let url = getApis[module]
    let res = await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body:JSON.stringify(inputData)
    })
    res = await res.json()
    return {
      id: res['_id'],
      ...res,
    };
  }
  catch (err) {
    console.log(err)
    errorHandler({
      status: 400,
      statusText: err,
      statusRaw: err,
    });
    return false;
  }
  // const ref = moduleGetDB(module, params).doc(params.id);
  // return stream
  //   ? streamRead(ref, { params, no404error })
  //   : await queryRead(ref, { params, no404error });
};
// Get list of documents
const queryList = async ({ module, conditions, attributes }) => {
  let docs = [];
  try {
    let token = await AuthService.getToken()
    let req = 'list';
    if (module == 'mergeStats')
    {
      req = 'mergelist';
    }
    let url = (listApis[module])?listApis[module]:`${config.functionsApi}/${module}/${req}`

  let inputData = {conditions,attributes} 
    let res = await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body:JSON.stringify(inputData)
          })
    
    res = await res.json()
    res.forEach(doc => {
      docs.push({
        id: doc['_id'],
        ...doc,
      });
    });
    return docs
  } catch (err) {
    errorHandler({
      status: 400,
      statusText: err,
      statusRaw: err,
    });
    return false;
  }
};
// Get list of documents and listen for changes
const streamList = async ({ params, module, socket, conditions, attributes }) => {
  let token = await AuthService.getToken()
  let inputData ={
    'conditions':conditions,'attributes':attributes
  }
  console.log(JSON.stringify(inputData));
  console.log(module);
  let url = (listApis[module])?listApis[module]:`${config.functionsApi}/${module}/list`
  return eventChannel((emitter) => {
    fetch(url, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(inputData)
    }).then(res => {
      if (res.status >= 400 && res.status < 600) {
        throw new Error("Bad response from server");
      }
      res.json().then((data => {
        if (data) {
          data.map(x => x.id = x['_id'])
          emitter(data)
        }
      }))
    }).catch(err => {
      errorHandler({
        status: 400,
        statusText: err,
        statusRaw: err,
      });
      emitter([]);
    })
    socket.on(params.socketId, function (data) {
      if (!conditions || (data.machine == conditions.machine || data.operationType == 'delete'))
        emitter(data)
    });

    // The subscriber must return an unsubscribe function
    return () => {
      socket.emit('leave', params.socketId)
      socket.off(params.socketId)
      if (window.rooms)
        window.rooms = window.rooms.filter(x => x != params.socketId)
    }

    // unsubscribe()
  });
};
// Get a document
const queryRead = async (ref, { params }) => {
  let docs = [];
  try {
    const doc = await ref.get();
    if (doc.exists) {
      return {
        id: doc.id,
        ...doc.data(),
      };
    } else return false;
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};
// Get a document and listen to changes
const streamRead = async (ref, { params, no404error = false }) => {
  return eventChannel(emitter => {
    const unsubscribe = ref.onSnapshot(
      async querySnapshot => {
        let singleDoc = false;
        if (querySnapshot.exists) {
          singleDoc = {
            id: querySnapshot.id,
            ...querySnapshot.data(),
          };
        } else {
          console.log('404 read', module + ' doesnt exist with id' + params.id);
          if (!no404error) {
            errorHandler({
              status: 404,
              statusText: module + ' doesnt exist with id' + params.id,
            });
          }
        }
        emitter(singleDoc);
        singleDoc = {};
      },
      err => {
        errorHandler({
          status: err.code,
          statusText: err.message,
          statusRaw: err,
        });
        emitter(false);
      }
    );
    // The subscriber must return an unsubscribe function
    return () => unsubscribe();
  });
};
export const create = async ({ module, params, data }) => {
  const id = params && params.id ? params.id : moduleGenerateId(module, params, data);
  try {
    // let ref = moduleGetDB(module, params);
    const inputData = {
      createdAt: new Date(),
      ...data,
    };
    let result = ''
    // if (useFirestoreId) {
    //   const snapShot = await ref.add(inputData);
    //   result = snapShot.id;
    // } else {
    inputData['_id'] = id
    if (params) {
      if (params.productionLineId)
        inputData.lineId = params.productionLineId
      if (params.plantId)
        inputData.plantId = params.plantId
    }
    let token = await AuthService.getToken()
    let url = createApis[module]
    let response = await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(inputData)
    })
    // await ref.doc(id).set(inputData);
    if (response.status != 200) {
      errorHandler({
        status: response.status,
        statusText: "Access Restricted",
        statusRaw: "Access Restricted",
      });
      return false
    }

    result = id;


    if (params != null && params.log != null)
      await createLog(params.log)
    return result
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};

export const dynamicAdjustmentsForTreet = async (module, params, data) => {
  const id = params && params.id ? params.id : moduleGenerateId(module, params, data);
  try {
    // let ref = moduleGetDB(module, params);
    const inputData = {
      createdAt: new Date(),
      ...data,
    };
    let result = ''
    // if (useFirestoreId) {
    //   const snapShot = await ref.add(inputData);
    //   result = snapShot.id;
    // } else {
    inputData['_id'] = id
    if (params) {
      if (params.productionLineId)
        inputData.lineId = params.productionLineId
      if (params.plantId)
        inputData.plantId = params.plantId
      if (params.createdAt)
        inputData.createdAt = params.createdAt  
    }
    let token = await AuthService.getToken()
    let url = createApis['dynamicAdjustments']
    let response = await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(inputData)
    })
    // await ref.doc(id).set(inputData);
    if (response.status != 200) {
      errorHandler({
        status: response.status,
        statusText: "Access Restricted",
        statusRaw: "Access Restricted",
      });
      return false
    }

    result = response;


    if (params != null && params.log != null)
      await createLog(params.log)
    return result
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};

export const machineBatchOperation = async (data) => {
  try {
    let token = await AuthService.getToken()
    for (let doc of data.insertDocs) {
      doc['_id'] = generateId(`${data.collectionId.substr(0, 2)}`)
    }
    let url = apis['bulkSyncMachines']
    await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    })
    return true
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};

export const syncMachineShifts = async (data) => {
  try {
    let token = await AuthService.getToken()
    let url = apis['SyncShifts']
    await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    })
    return true
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};





export const machineBatchQuery = async (data) => {
  try {
    let token = await AuthService.getToken()
    let url = apis['productBatchQuery']
    let results = await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    })
    //results = JSON.parse(results);
    console.log(results);
    results = await results.json()
    console.log(results)
    results = JSON.parse(results.body)
    console.log(results);
    //results = await results.json()
    //console.log(results)
    // let results = {}
    // for (let machineId of query.machineIds) {
    //   let ref = moduleGetDB(module, {
    //     machine: machineId,
    //     productionLineId: query.productionLineId
    //   })
    //   if (conditions) {
    //     conditions.map(condition => {
    //       if (condition.length < 3) {
    //         return console.error('Incorrect condition provided for firestore');
    //       }
    //       ref = ref.where(condition[0], condition[1], condition[2]);
    //     });
    //   }
    //   let snapshot = await ref.limit(1).get()
    //   let singleDocument = null;
    //   snapshot.forEach(doc => {
    //     if (doc.exists) {
    //       singleDocument = doc.data();
    //       singleDocument.id = doc.id
    //     }
    //   });
    //   results[machineId] = singleDocument
    // }
    return results
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};



export const createMachine = ({ productionLine, products, dynamicAdjustments, plannedDowntimes, machine }) => {
  return new Promise(async (resolve, reject) => {
    productionLine = {
      updatedAt: new Date(),
      '_id': productionLine.id,
      ...productionLine,
    }
    delete productionLine['id']
    products.map(record => {
      record['_id'] = generateId(`${'products'.substr(0, 2)}`)
      delete record['id']
    })
    dynamicAdjustments.map(record => {
      record['_id'] = generateId(`${'dynamicAdjustments'.substr(0, 2)}`)
      delete record['id']
    })
    plannedDowntimes.map(record => {
      record['_id'] = generateId(`${'plannedDowntimes'.substr(0, 2)}`)
      delete record['id']
    })
    let token = await AuthService.getToken()
    let url = apis['createMachine']
    await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ productionLine, products, dynamicAdjustments, plannedDowntimes, machine })
    })

    // const snapshot = await firestore
    //   .collection('productionLine')
    //   .doc(id)
    //   .update({
    //     ...data,
    //   });
    // if (log != null) createLog(log);
    resolve(true);
  });
};
export const update = async ({ module, params, data }) => {
  try {
    // const ref = moduleGetDB(module, params);
    // await ref.doc(params.id).update({
    //   updatedAt: new Date(),
    //   ...data,
    // });
    let inputData = {
      updatedAt: new Date(),
      '_id': params.id,
      ...data,
    }
    delete inputData['id']
    let token = await AuthService.getToken()
    let url = updateApis[module];
    await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(inputData)
    })

    if (params != null && params.log != null)
      await createLog(params.log)
    return true;
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};
// cant name it 'delete' as its reserved in JS
export const remove = async ({ module, params, data }) => {
  try {
    // const ref = moduleGetDB(module, params);
    let token = await AuthService.getToken()
    let inputData = {id:params.id,lineId:params.productionLineId,plantId:params.plantId}
    let url = deleteApis[module];
    await fetch(url, {
      method: 'delete',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body:JSON.stringify(inputData)
    })

    // await ref.doc(params.id).delete();
    if (params != null && params.log != null)
      await createLog(params.log)
    return true;
  } catch (err) {
    errorHandler({
      status: err.code,
      statusText: err.message,
      statusRaw: err,
    });
    return false;
  }
};
